import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import RadioBox from './RadioBox.vue';
import { PROFILE_COLOR } from '@/shared/constans/profile';


export default /*@__PURE__*/_defineComponent({
  __name: 'PersonalColor',
  props: {
  selectColor: {
    type: String,
    default: '#00D696',
  },
},
  emits: ['update:selectColor'],
  setup(__props, { emit: __emit }) {



const colors = ref(PROFILE_COLOR);
const emit = __emit;
const handleColor = (index: number) => {
  emit('update:selectColor', colors.value[index].code);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colors.value, (color, index) => {
    return (_openBlock(), _createBlock(RadioBox, {
      key: index,
      name: "personal",
      id: color.color,
      modelValue: color.code,
      "onUpdate:modelValue": ($event: any) => ((color.code) = $event),
      color: color.color,
      onClick: ($event: any) => (handleColor(index)),
      checked: __props.selectColor == color.code
    }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "color", "onClick", "checked"]))
  }), 128))
}
}

})